export default function HeroSection() {
    return (
        <section className="bg-[#F7F5F0] pt-16 md:pt-24 pb-12">
            <div className="max-w-5xl mx-auto px-6 md:px-10 lg:px-14">
                <p className="text-[12px] uppercase tracking-[0.2em] text-[#C8A24A] font-medium">
                    Referrals
                </p>
                <h1 className="mt-3 font-[Outfit] text-4xl sm:text-5xl lg:text-6xl font-semibold tracking-tight leading-[1.05]">
                    A thoughtful and responsive referral process.
                </h1>
                <p className="mt-6 text-[17px] leading-relaxed text-[#6F6B63] max-w-3xl">
                    <strong className="text-[#0E2A47] font-semibold">
                        Crossroads to Change Residential Treatment Center
                    </strong>{" "}
                    partners with DFPS Placement Teams, SSCC Placement
                    Coordinators, juvenile probation departments, case
                    managers, caregivers, hospitals, crisis units, schools,
                    and community partners to support young men in need of
                    structure, stabilization, and therapeutic care.
                </p>
                <p className="mt-4 text-[17px] leading-relaxed text-[#6F6B63] max-w-3xl">
                    Every referral is reviewed individually by our team to
                    ensure appropriate placement fit, safety, and support
                    needs, with timely communication throughout the
                    admissions process.
                </p>
            </div>
        </section>
    );
}
